import { findLocationModalStyles } from "@insite/content-library/Components/FindLocationModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

findLocationModalStyles.currentlySelectedGridContainer = {
    css: css`
        padding: 20px;
    `,
};
